import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toastOptions } from 'app/shared/componentsRestyled/coreDesignSystem/AlertsCDS/AlertCDS/AlertCDS.constants';

import { hideMessageAction } from 'store/global/actions';
import { selectMessages } from 'store/global/selectors';

const useAlerts = () => {
  const dispatch = useDispatch();
  const messages = useSelector(selectMessages);
  const timersRef = useRef({});

  const hideMessage = useCallback(
    id => {
      dispatch(hideMessageAction(id));

      if (timersRef.current[id]) {
        clearTimeout(timersRef.current[id]);
        delete timersRef.current[id];
      }
    },
    [dispatch],
  );

  useEffect(() => {
    const timers = timersRef.current;
    const currentIds = messages.map(m => m.id);

    Object.keys(timers).forEach(id => {
      if (!currentIds.includes(id) && !currentIds.includes(Number(id))) {
        clearTimeout(timers[id]);
        delete timers[id];
      }
    });

    messages.forEach(({ id, duration = toastOptions.autoHideDuration }) => {
      if (!timers[id]) {
        timers[id] = setTimeout(() => {
          hideMessage(id);
        }, duration);
      }
    });
  }, [messages, hideMessage]);

  useEffect(() => {
    const timers = timersRef.current;

    return () => {
      Object.values(timers).forEach(clearTimeout);
    };
  }, []);

  return {
    messages,
    hideMessage,
  };
};

export default useAlerts;
